var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-multi-select-tag',{attrs:{"disabled":_vm.disabled,"type":"list_multi","dictCode":_vm.dictcode},on:{"change":_vm.commonComponent},model:{value:(_vm.fcz.commonDataInfo),callback:function ($$v) {_vm.$set(_vm.fcz, "commonDataInfo", $$v)},expression:"fcz.commonDataInfo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }